export default function numberInputFormatter(Utils, displayNumberFilter, sdk) {
  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModel) {
      $ngModel.$parsers.push((value) => {
        if (!value) {
          return value;
        }

        const decimalFormat = Utils.getDecimalFormat();
        const { DECIMAL_FORMAT_THOUSANDS_COMMA_DECIMAL_DOT } = sdk('constants');

        if (decimalFormat === DECIMAL_FORMAT_THOUSANDS_COMMA_DECIMAL_DOT) {
          return value.replace(',', '');
        }

        return value.replace('.', '').replace(',', '.');
      });

      $ngModel.$formatters.push((value) => {
        if (value !== 0 && !value) {
          return '';
        }

        return displayNumberFilter(value, false);
      });
    },
  };
}
